import { Stat as ChakraStat, StatProps } from '@chakra-ui/react';
import * as React from 'react';

const Stat: React.FC<React.PropsWithChildren<StatProps>> = (props) => (
  <ChakraStat
    px={{ base: 4, laptop: 6 }}
    py="5"
    bg="white"
    shadow="base"
    rounded="lg"
    {...props}
  />
);

export default Stat;
